export const NO_RECORDS_FOUND = "No records found";